import {IDebtorDetails} from './debtors';
import {IQuoteComposeEntry} from './quote-compose-entry.interface';
import {IQuoteListItem} from './quote-list-item.interface';
import {IQuoteStockItem} from './quoteStockItems';
import {extractQuoteItemsFromComposeEntries} from '../utils/quote-compose-entry.utils';

export const QUOTES_LOCAL_DRAFTS_STORAGE_KEY = 'quotes-local-drafts';
export const QUOTE_LOCAL_DRAFT_ID_PREFIX = 'local-';

export const QUOTE_LOCAL_DRAFT_STATUS = 'LOCAL DRAFT';

export const QUOTES_LOCAL_DRAFT_MAX_COUNT = 10;

/**
 * Quote compose draft persisted in localStorage (keyed by draft id, not debtor).
 */
export interface IQuoteLocalDraft {
  comment: string;
  createdAt: string;
  debtor: IDebtorDetails;
  id: string;
  storeId: string;
  updatedAt: string;
  composeEntries?: IQuoteComposeEntry[];
  /** @deprecated Use composeEntries — kept for legacy localStorage drafts. */
  items?: IQuoteStockItem[];
}
/**
 * Returns true when the id refers to a local draft rather than a Firestore quote.
 */
export const isQuoteLocalDraftId = (quoteId: string | null | undefined): boolean => {
  const id = (quoteId ?? '').trim();
  return id.startsWith(QUOTE_LOCAL_DRAFT_ID_PREFIX);
};

/**
 * Creates a new local draft identifier.
 */
export const createQuoteLocalDraftId = (): string => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return `${QUOTE_LOCAL_DRAFT_ID_PREFIX}${crypto.randomUUID()}`;
  }
  return `${QUOTE_LOCAL_DRAFT_ID_PREFIX}${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
};

/**
 * Maps a local draft to a quotes list row.
 */
export const mapQuoteLocalDraftToListItem = (draft: IQuoteLocalDraft): IQuoteListItem => ({
  id: draft.id,
  creationDate: new Date(draft.createdAt),
  debtorId: (draft.debtor.debtorId ?? draft.debtor.account ?? '').trim(),
  debtorName: draft.debtor.name ?? 'Unknown debtor',
  documentNo: '',
  emailStatus: '',
  itemCount: extractQuoteItemsFromComposeEntries(
    draft.composeEntries ?? draft.items?.map((item: IQuoteStockItem) => ({kind: 'item' as const, item})) ?? [],
  ).length,
  iqStatus: '',
  pdfStatus: '',
  processedDate: null,
  status: QUOTE_LOCAL_DRAFT_STATUS,
  storeId: draft.storeId,
  userId: '',
  isLocalDraft: true,
});
